import { render, staticRenderFns } from "./style.vue?vue&type=template&id=6b16789a"
import script from "./style.vue?vue&type=script&lang=js"
export * from "./style.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports